import JumbotronSubcategory from './JumbotronSubcategory'

export default JumbotronSubcategory
// eslint-disable-next-line import/export
export * from './JumbotronSubcategory'
